import { computed, useAttrs, type ComputedRef } from "vue";

/** Атрибуты для самого поля (`aria-*`, `id`, `name`); class и style остаются обёртке. */
export function useFieldAttrs(): ComputedRef<Record<string, unknown>> {
  const attrs = useAttrs();

  return computed(() =>
    Object.fromEntries(
      Object.entries(attrs).filter(
        ([key]) => key !== "class" && key !== "style",
      ),
    ),
  );
}
